import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { UserShowPage } from './user-show';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		UserShowPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(UserShowPage),
	],
})
export class UserShowPageModule {}



// WEBPACK FOOTER //
// ./src/pages/user-show/user-show.module.ts